import { SubsessionStatus } from '@zoom/videosdk';
export const SubsessionStatusDescription = {
  [SubsessionStatus.NotStarted]: 'Not Started',
  [SubsessionStatus.InProgress]: 'In Progress',
  [SubsessionStatus.Closing]: 'Closing',
  [SubsessionStatus.Closed]: 'Closed'
};
